var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#081132",
    fillRule: "evenodd",
    d: "M0 2.745C0 1.23 1.23 0 2.745 0H7.3c1.516 0 2.745 1.23 2.745 2.745V7.3c0 1.516-1.23 2.745-2.745 2.745H2.745C1.23 10.045 0 8.815 0 7.3V2.745zm2.745-.67c-.37 0-.67.3-.67.67V7.3c0 .37.3.67.67.67H7.3c.37 0 .67-.3.67-.67V2.745c0-.37-.3-.67-.67-.67H2.745zM0 14.7c0-1.516 1.23-2.745 2.745-2.745H7.3c1.516 0 2.745 1.23 2.745 2.745v4.555C10.045 20.77 8.815 22 7.3 22H2.745C1.23 22 0 20.77 0 19.255V14.7zm2.745-.67c-.37 0-.67.3-.67.67v4.555c0 .37.3.67.67.67H7.3c.37 0 .67-.3.67-.67V14.7c0-.37-.3-.67-.67-.67H2.745zM11.955 2.745C11.955 1.23 13.185 0 14.7 0h4.555C20.77 0 22 1.23 22 2.745V7.3c0 1.516-1.23 2.745-2.745 2.745H14.7c-1.516 0-2.745-1.23-2.745-2.745V2.745zm2.745-.67c-.37 0-.67.3-.67.67V7.3c0 .37.3.67.67.67h4.555c.37 0 .67-.3.67-.67V2.745c0-.37-.3-.67-.67-.67H14.7zM13.095 14.413c0-.73.592-1.322 1.323-1.322.73 0 1.322.592 1.322 1.322 0 .73-.592 1.322-1.322 1.322-.73 0-1.323-.592-1.323-1.322zM13.095 19.539c0-.73.592-1.323 1.323-1.323.73 0 1.322.592 1.322 1.323 0 .73-.592 1.322-1.322 1.322-.73 0-1.323-.592-1.323-1.322zM18.216 14.413c0-.73.592-1.322 1.323-1.322.73 0 1.322.592 1.322 1.322 0 .73-.592 1.322-1.322 1.322-.73 0-1.323-.592-1.323-1.322zM18.216 19.539c0-.73.592-1.323 1.323-1.323.73 0 1.322.592 1.322 1.323 0 .73-.592 1.322-1.322 1.322-.73 0-1.323-.592-1.323-1.322z",
    clipRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.ef34fc23.svg";
export { ForwardRef as ReactComponent };